import { Injectable, inject } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { UserProfileStore } from '../../store/user-profile.store';

export interface PermissionWithRolesDto {
  id: number;
  description: string;
  roleIds: number[];
}

@Injectable({ providedIn: 'root' })
export class PermissionAdminService {
  private userProfileStore = inject(UserProfileStore);
  constructor(private api: ApiService) {}

  getPermissionsWithRoles(): Observable<PermissionWithRolesDto[]> {
  return this.api.get('permissions/with-roles') as Observable<PermissionWithRolesDto[]>;
  }

  updatePermissionRoles(permissionId: number, roleIds: number[]): Observable<void> {
    const email = this.getCurrentEmail();
    return this.api.put('permissions/roles', { permissionId, roleIds, email }) as unknown as Observable<void>;
  }

  private getCurrentEmail(): string | null {
    // Prefer the in-memory store; fallback to localStorage if unavailable
    try {
      const storeEmail = this.userProfileStore.userProfile().email;
      if (storeEmail) return storeEmail;
    } catch {}

    try {
      const raw = localStorage.getItem('user');
      if (raw) {
        const u = JSON.parse(raw);
        return u?.mail || u?.email || u?.userPrincipalName || null;
      }
      return localStorage.getItem('email');
    } catch {
      return null;
    }
  }
}
